import { useUserActivityStore } from "@/stores/UserActivityStore";
import { useUserStore } from "@/stores/UserStore";

export const logPageVisit = (to, from, extraMeta = {}) => {
  const userActivityStore = useUserActivityStore();
  const userStore = useUserStore();

  const metaData = {
    label: to.name
      .replace(/_/g, " ")
      .replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase()),
    route: to.fullPath,
    params: Object.values(to.params).join(", "),
    query: to.query,
    org: userStore.currentOrg?.id,
    from: from?.fullPath,
    ...extraMeta,
  };

  userActivityStore.create({
    event: "page visit",
    meta_data: metaData,
  });
};

export const logDownloadEvent = (page, download_type, tab) => {
  const userActivityStore = useUserActivityStore();
  const event = `${page}${tab ? "_" + tab : ""}_download_${download_type}`;
  userActivityStore.create({
    event,
    meta_data: {
      page,
      download_type,
      ...(tab && { tab }),
    },
  });
};
